import React from 'react'
import CurrentUser from 'components/CurrentUser'

export default Component => props => (
  <CurrentUser
    render={({ viewer }) => <Component currentUser={viewer} {...props} />}
  />
)



// WEBPACK FOOTER //
// ./src/components/withCurrentUser.js